module.exports = __webpack_public_path__ + "static/media/Cal-the-Musical-backcrosses.fb497ec7.jpg";